var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "modal fade",
        {
          show: _vm.getIsShowDeleteBriefing,
          "d-block": _vm.getIsShowDeleteBriefing,
          notAllowClick: _vm.getIsLoadingDeleteBriefing,
        },
      ],
      staticStyle: { display: "block" },
      attrs: { tabindex: "-1", "aria-hidden": "true" },
    },
    [
      _c("div", { staticClass: "modal-dialog go-modal-confirm" }, [
        _vm.getIsDeleteSingleBriefing
          ? _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-body" }, [
                _c("i", { staticClass: "go-icon-40 go-icon-trash" }),
                _vm._v(" "),
                _c("p", { staticClass: "lead" }, [
                  _vm._v("\n          '"),
                  _c("strong", [
                    _vm._v(_vm._s(_vm.getCurrentDeleteBriefingName)),
                  ]),
                  _vm._v("'"),
                  _c("br"),
                  _vm._v(
                    _vm._s(_vm.$t("scrap-agent.delete-popup.single.question")) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    _vm._s(_vm.$t("scrap-agent.delete-popup.single.warn"))
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn go-btn-default",
                    attrs: {
                      type: "button",
                      "data-dismiss": "modal",
                      disabled: _vm.getIsLoadingDeleteBriefing,
                    },
                    on: { click: _vm.handleCancelDelete },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t("briefing.popup.deleteBriefing.button.cancel")
                        ) +
                        "\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn go-btn-primary",
                    attrs: {
                      type: "button",
                      disabled: _vm.getIsLoadingDeleteBriefing,
                    },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.emitHandleDeleteSingleBriefing.apply(
                          null,
                          arguments
                        )
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("scrap-agent.delete")) +
                        "\n        "
                    ),
                  ]
                ),
              ]),
            ])
          : _c("div", { staticClass: "modal-content" }, [
              _c(
                "div",
                { staticClass: "modal-body" },
                [
                  _c("i", { staticClass: "go-icon-40 go-icon-trash" }),
                  _vm._v(" "),
                  _c("p", {
                    staticClass: "lead",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t("scrap-agent.delete-popup.multi.question", {
                          n: _vm.getNumberOfDeleteBriefings,
                        })
                      ),
                    },
                  }),
                  _vm._v(" "),
                  _c("P", [
                    _vm._v(
                      _vm._s(_vm.$t("scrap-agent.delete-popup.multi.warn"))
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn go-btn-default",
                    attrs: {
                      type: "button",
                      disabled: _vm.getIsLoadingDeleteBriefing,
                    },
                    on: { click: _vm.handleCancelDelete },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t("briefing.popup.deleteBriefing.button.cancel")
                        ) +
                        "\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn go-btn-primary",
                    attrs: {
                      type: "button",
                      disabled: _vm.getIsLoadingDeleteBriefing,
                    },
                    on: { click: _vm.emitHandleDeleteBriefings },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t("briefing.popup.deleteBriefing.button.delete")
                        ) +
                        "\n        "
                    ),
                  ]
                ),
              ]),
            ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }